import {WlShare} from "./share.component";

export * from './share.component';
export default WlShare;

customElements.define('wl-share', WlShare);
